export function CssGfg() {
    const courses = [
        { title: "Basic CSS Syntax", link: "https://www.geeksforgeeks.org/css-syntax/?ref=lbp" },
        { title: "CSS Selectors", link: "https://www.geeksforgeeks.org/css-selectors/?ref=lbp" },
        { title: "CSS Colors", link: "https://www.geeksforgeeks.org/css-colors/?ref=lbp" },
        { title: "CSS Borders", link: "https://www.geeksforgeeks.org/css-borders/?ref=lbp" },
        { title: "CSS Margins", link: "https://www.geeksforgeeks.org/css-margins-padding/?ref=lbp" },
        { title: "CSS Height & Width", link: "https://www.geeksforgeeks.org/css-height-and-width/?ref=lbp" },
        { title: "CSS Fonts", link: "https://www.geeksforgeeks.org/css-fonts/?ref=lbp" },
        { title: "CSS Attribute Selectors", link: "https://www.geeksforgeeks.org/css-attribute-selector/?ref=lbp" },
        { title: "CSS Flexbox", link: "https://www.geeksforgeeks.org/css-flexbox-and-its-properties/?ref=lbp" },
        { title: "CSS Animations", link: "https://www.geeksforgeeks.org/css-animations/?ref=lbp" },
        { title: "CSS Box Model", link: "https://www.geeksforgeeks.org/css-box-model/?ref=lbp" },
    ];

    return (
        <>
            <h1 className="html_gfg_heading">
                These are the <strong style={{ textDecoration: 'underline', color: 'blue' }}>Top 10</strong> recommended Geeks for Geeks links that you can refer with important topics
            </h1>

            <h4 className="des_co_html">
                1. Dive Into The <strong>Main</strong> Concepts <br />
                2. Enough Concepts to Learn & Understand <br />
                3. Only Important Concepts to Learn Through Every Topic
            </h4>

            {/* Render all courses dynamically */}
            {courses.map((course, index) => (
                <div className="container_html_gfg_links" key={index}>
                    <p className="vid">
                        {index + 1}. {course.title}
                        <button
                            style={{
                                marginLeft: '200px',
                                padding: '7px',
                                background: 'black',
                                color: 'white',
                                borderRadius: '8px',
                            }}
                            onClick={() => window.open(course.link, "_blank")}
                        >
                            Click Me
                        </button>
                    </p>
                </div>
            ))}
        </>
    );
}

export default CssGfg;
